/** @format */

export default function key(...args) {
  return { key: JSON.stringify(args) };
}
